import type { ReactNode } from "react";

export enum SubagentStatus {
  Pending = "pending",
  Completed = "completed",
}

export interface SubagentIndicatorProps {
  subagentType?: string;
  description?: string;
  status: SubagentStatus;
  /** What the subagent is doing now (e.g. "Calling get_envs"), shown while it runs. */
  activity?: string;
  isError?: boolean;
  children?: ReactNode;
  "data-test-id"?: string;
}
